export type AppConfig = {
    API_URL: string;
  };
  
  let configPromise: Promise<AppConfig> | null = null;

  export function loadConfig(): Promise<AppConfig> {
    if (!configPromise) {
      const url = '/trav-referral/config.json';
      configPromise = fetch(url)
        .then((res) => {
          if (!res.ok) {
            throw new Error(`Failed to load config.json: ${res.status}`);
          }
          return res.json();
        })
        .then((json) => {
          return json;
        })
        .catch((err) => {
          throw err;
        });
    }
    return configPromise;
}